import React from 'react'
import { Link } from 'react-router-dom'

import './style.scss'

const Index = () => {
    return(
        <div className="dashboard-validate-error-container">
            <div className="inner-dashboard-validate-error-container">
                <h1 className="error-icon"><i class="far fa-frown"></i></h1>
                <h3 className="error-title">Betaling ble brutt</h3>
                <p className="error-description">Kunne ikke gjennomføre betaling, trykk <Link to="/dashboard/foretak/ny">her</Link> for å gå tilbake.</p>
            </div>
        </div>
    )
}

export default Index